import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = ["d"];
import { ref, provide, onMounted, onUnmounted, watch, nextTick } from 'vue';
import SkillsNode from '@/components/Skills/SkillsNode.vue'; // constants

const itemHeight = 16;
const itemFontSize = 16 * 0.75;
const itemPaddingVertical = 28;
const itemPaddingHorizontal = 32;
export default {
  __name: 'SkillsTree',
  props: {
    roleId: {
      type: [String, Number],
      default: null,
      required: false
    },
    data: {
      type: Object,
      required: true
    }
  },

  setup(__props) {
    let frameDataBuffer = {}; // pre-declaration

    const props = __props; // refs

    const frameData = ref({});
    const containerRef = ref(null);
    const svgRef = ref(null);
    const containerWidth = ref(0); // functions

    const updateContainerWidth = () => {
      if (containerRef.value) {
        containerWidth.value = containerRef.value.getBoundingClientRect().width;
      }
    };

    const getWidthWithSubsequent = skills => {
      let width = Math.max(...skills.map(item => item.name.length)) * itemFontSize * 1.2;
      let buffer = skills.filter(item => item.subsequent).map(item => item.subsequent).flat(); // console.log(JSON.stringify(skills.map(item => item.name)), JSON.stringify(buffer.map(item => item.name)))

      if (buffer.length !== 0) {
        width += getWidthWithSubsequent(buffer) + itemPaddingHorizontal * 0.5;
      }

      return width;
    };

    const getHeightWithSubsequent = skill => {
      let height = 0;

      if (skill.subsequent) {
        skill.subsequent.map(item => {
          height += getHeightWithSubsequent(item);
        });

        if (skill.subsequent.length > 1) {
          height += (skill.subsequent.length - 1) * (itemPaddingVertical * 0.5);
        }

        return height;
      }

      return itemHeight;
    };

    const generateSubsequentViewData = (array, x, y, preSkillFrame) => {
      let width = Math.max(...array.map(item => item.name.length)) * itemFontSize * 1.2;
      let sumHeight = array.length * itemHeight + (array.length - 1) * itemPaddingVertical * 0.5;
      let itemY = y - sumHeight * 0.5;
      array.map(item => {
        frameDataBuffer[`subsequent_skill_${item.id}`] = {
          x,
          y: itemY,
          width,
          height: itemHeight,
          preSkillFrame: preSkillFrame
        }; // console.log(`记录subsequent_skill_${item.id} ${JSON.stringify(frame)}`)

        addConnectorItem(item);
        itemY += itemHeight + itemPaddingVertical * 0.5;
      });
      let buffer = array.filter(item => item.subsequent); // console.log(`buffer = ${JSON.stringify(buffer)}`)

      let widthArray = [];
      buffer.map(item => {
        const skillFrameData = frameDataBuffer[`subsequent_skill_${item.id}`]; // console.log(`subsequent_skill_${item.id} 找到前置${JSON.stringify(skillFrameData)}`)

        widthArray.push(generateSubsequentViewData(item.subsequent, skillFrameData.width + itemPaddingHorizontal * 0.5, skillFrameData.height * 0.5, {
          x: skillFrameData.x + preSkillFrame.x,
          y: skillFrameData.y + preSkillFrame.y,
          width: skillFrameData.width,
          height: skillFrameData.height
        }));
      });

      if (widthArray.length > 0) {
        width += Math.max(...widthArray) + itemPaddingHorizontal * 0.5;
      }

      return width;
    };

    const generateViewData = async () => {
      frameData.value = {};
      frameDataBuffer = {};
      connectorData.value = []; // console.log('generateViewData')

      let x = 64;
      let y = 0;
      let interval = 0;
      const degreeKeys = Object.keys(props.data);
      const degreeWidthDict = {};
      if (degreeKeys.length === 0) return;

      if (containerRef.value) {
        let sumWidth = 0;
        Object.entries(props.data).map(([degreeKey, degreeSkills]) => {
          const degreeWidth = getWidthWithSubsequent(degreeSkills);
          degreeWidthDict[degreeKey] = degreeWidth;
          sumWidth += degreeWidth;
        });

        if (degreeKeys.length === 1) {
          interval = 0;
        } else {
          interval = (containerWidth.value - sumWidth - 2 * x) / (degreeKeys.length - 1);
        }
      } else {
        await nextTick();
        generateViewData();
        return;
      }

      let width = 0;
      const height = itemHeight * 1.8;
      let maxHeight = 0; // console.log(`invoke generateViewData ${JSON.stringify(props.data)}`)

      Object.entries(props.data).map(([degreeKey, degreeSkills], degreeIndex) => {
        // console.log(degreeKey, degreeSkills.length, degreeIndex)
        let skillWidth = Math.max(...degreeSkills.map(item => item.name.length)) * itemFontSize * 1.2; // width = Math.min(Math.max(64, skillWidth), 240)

        width = degreeWidthDict[degreeKey];
        frameDataBuffer[`degree_${degreeIndex}`] = {
          x,
          y,
          width,
          height
        }; // let centerX = x + skillWidth * 0.5

        let skillY = y + height + itemPaddingVertical;
        let skillHeight = itemHeight;
        let maxSubsequentWidth = [];
        degreeSkills.map(skill => {
          const heightWithSubsequent = getHeightWithSubsequent(skill);
          skillY += (heightWithSubsequent - skillHeight) * 0.5;
          const frame = {
            x: x,
            y: skillY,
            width: skillWidth,
            height: skillHeight
          };
          frameDataBuffer[`skill_${skill.id}`] = frame;

          if (skill.subsequent) {
            maxSubsequentWidth.push(generateSubsequentViewData(skill.subsequent, skillWidth + itemPaddingHorizontal * 0.5, skillHeight * 0.5, frame));
          } else if (skill.pre_skill) {// addConnectorItem(skill)
          }

          skillY += skillHeight + itemPaddingVertical + (heightWithSubsequent - skillHeight) * 0.5;
        });

        if (skillY >= maxHeight) {
          maxHeight = skillY;
        } // console.log(`skillWidth = ${skillWidth} maxSubsequentWidth = ${JSON.stringify(maxSubsequentWidth)} `)


        width += interval;

        if (maxSubsequentWidth.length > 0) {
          width += Math.max(...maxSubsequentWidth) + itemPaddingHorizontal * 0.5;
        }

        x += width;
      });
      frameData.value = frameDataBuffer; // console.log('frameData.value更新')

      if (containerRef.value) {
        containerRef.value.style.height = `${maxHeight}px`;
        svgRef.value.style.height = `${maxHeight}px`;
      }
    };

    const connectorData = ref([]);

    const addConnectorItem = item => {
      connectorData.value.push({
        'skill_id': item.id,
        'pre_skill_id': item.pre_skill.id,
        'path': getConnectorPath(item.pre_skill.id, item.id)
      });
    };

    const getConnectorPath = (pre_skill_id, skill_id) => {
      let pre_skill_key = `skill_${pre_skill_id}`;
      let skill_key = `skill_${skill_id}`;
      let startFrameData = frameDataBuffer[pre_skill_key];
      let endFrameData = frameDataBuffer[skill_key];

      if (!startFrameData) {
        pre_skill_key = `subsequent_skill_${pre_skill_id}`;
        startFrameData = frameDataBuffer[pre_skill_key];
      }

      if (!endFrameData) {
        skill_key = `subsequent_skill_${skill_id}`;
        endFrameData = frameDataBuffer[skill_key];
      }

      if (!startFrameData || !endFrameData) {
        return;
      } // console.log(`前置技能${pre_skill_id} 连接技能${skill_id}`)
      // console.log(JSON.stringify(startFrameData), JSON.stringify(endFrameData))


      let startX = startFrameData.x + startFrameData.width;
      let startY = startFrameData.y + startFrameData.height * 0.5;
      let endX = endFrameData.x;
      let endY = endFrameData.y + endFrameData.height * 0.5;

      if (pre_skill_key.startsWith('subsequent_skill')) {
        // console.log(`root_skill_id = ${endFrameData['root_skill_id']} rootFrameData = ${JSON.stringify(rootFrameData)}`)
        startX += startFrameData.preSkillFrame.x;
        startY = startFrameData.preSkillFrame.y + startFrameData.preSkillFrame.height * 0.5 + startFrameData.y;
      }

      if (skill_key.startsWith('subsequent_skill')) {
        endX = endFrameData.x + endFrameData.preSkillFrame.x;
        endY = endFrameData.y + endFrameData.preSkillFrame.y + endFrameData.preSkillFrame.height * 0.5;
      } // console.log('path: ', startX, startY, endX, endY)


      return `M ${startX} ${startY} L ${endX} ${endY}`; //   return `M 100 100 C 100 75, 50 75, 50 50`
      // return `
      // M ${startX} ${startY}
      // L ${startX} ${startY + 10}
      // L ${endX} ${endY + 10}
      // L ${endX} ${endY}`
      // 贝塞尔曲线路径
      // return `
      // M ${startX} ${startY} L ${startX} ${startY + 10}
      // C ${startX} ${startY + (endY - startY) / 2}, ${endX} ${startY + (endY - startY) / 2}, ${endX} ${endY + 10}
      // L ${endX} ${endY}`
    };

    const frameToStyle = frame => {
      return {
        left: `${frame.x}px`,
        top: `${frame.y}px`,
        width: `${frame.width}px`,
        height: `${frame.height}px`
      };
    };

    const getDegreeStyle = index => {
      const degreeFrameData = frameData.value[`degree_${index}`];

      if (!degreeFrameData) {
        // console.log(`没有找到degree_${index}`)
        return {};
      } // console.log(`找到degree_${index} ${JSON.stringify(degreeFrameData)}`)


      return {
        fontSize: `${itemFontSize * 1.2}px`,
        lineHeight: `${itemHeight * 1.2}px`,
        ...frameToStyle(degreeFrameData)
      };
    };

    const getSkillStyle = skill_id => {
      const skillFrameData = frameData.value[`skill_${skill_id}`];

      if (!skillFrameData) {
        // console.log(`没有找到skill_${skill_id}`)
        return {};
      } // console.log(`找到skill_${skill_id} ${JSON.stringify(skillFrameData)}`)


      return {
        fontSize: `${itemFontSize}px`,
        lineHeight: `${itemHeight}px`,
        ...frameToStyle(skillFrameData)
      };
    };

    const getSubsequentSkillStyle = skill_id => {
      const skillFrameData = frameData.value[`subsequent_skill_${skill_id}`];

      if (!skillFrameData) {
        // console.log(`没有找到subsequent_skill_${skill_id}`)
        return {};
      } // console.log(`找到subsequent_skill_${skill_id}, ${JSON.stringify(skillFrameData)}`)


      return {
        fontSize: `${itemFontSize}px`,
        lineHeight: `${itemHeight}px`,
        ...frameToStyle(skillFrameData)
      };
    }; // post-declaration


    provide('getSubsequentSkillStyle', getSubsequentSkillStyle); // lifecycle

    onMounted(() => {
      updateContainerWidth();
      window.addEventListener('resize', updateContainerWidth);
    });
    onUnmounted(() => {
      window.removeEventListener('resize', updateContainerWidth);
    }); // watcher

    watch(() => props.data, () => generateViewData(), {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "tree-container",
        ref_key: "containerRef",
        ref: containerRef
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (skills, degree, degreeIndex) => {
        return _openBlock(), _createElementBlock("div", {
          style: {
            "position": "relative"
          },
          key: degreeIndex
        }, [_createElementVNode("text", {
          class: "tree-degree",
          style: _normalizeStyle(getDegreeStyle(degreeIndex))
        }, _toDisplayString(degree) + "级", 5), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(skills, skill => {
          return _openBlock(), _createBlock(SkillsNode, {
            key: skill.id,
            style: _normalizeStyle(getSkillStyle(skill.id)),
            "role-id": __props.roleId,
            skill: skill
          }, null, 8, ["style", "role-id", "skill"]);
        }), 128))]);
      }), 128)), (_openBlock(), _createElementBlock("svg", {
        class: "tree-svg",
        ref_key: "svgRef",
        ref: svgRef
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(connectorData.value, item => {
        return _openBlock(), _createElementBlock("path", {
          key: `connector-${item.pre_skill_id}-${item.skill_id}`,
          d: item.path,
          stroke: "black",
          "stroke-width": "1",
          fill: "none"
        }, null, 8, _hoisted_1);
      }), 128))], 512))], 512)), [[_vShow, frameData.value]]);
    };
  }

};